export default __webpack_public_path__ + "static/media/call_web_dark.b95daa0b.png";